import {
  COLUMN_SUBDIVISIONS,
  getWidgetConstraints,
  initOptions,
} from '@/pages/landingPage/grid/widgetConstraints.ts';
import { assertTwoColumnWidgetLayoutConfigInDev } from '@/utils/twoColumnWidgetLayout/assertTwoColumnWidgetLayoutConfigInDev.ts';
import { LICE_COUNT_COMPONENT_NAME } from '@/widgetComponentNames.ts';

// Limits are in fine columns, so they scale with COLUMN_SUBDIVISIONS like every other width.
export const LICE_COUNT_TWO_COLUMN_WIDGET_LAYOUT = {
  firstChildLowerWidthLimit: 3 * COLUMN_SUBDIVISIONS,
  firstChildUpperWidthLimit: 5 * COLUMN_SUBDIVISIONS,
  firstChildWidth: 2 * COLUMN_SUBDIVISIONS,
} as const;

const liceCountWidgetConstraints = getWidgetConstraints(LICE_COUNT_COMPONENT_NAME);
const liceCountMinColumns = liceCountWidgetConstraints.minW ?? 1;
const gridColumnCount = typeof initOptions.column === 'number' ? initOptions.column : 12;
const liceCountMaxColumns = liceCountWidgetConstraints.maxW ?? gridColumnCount;

assertTwoColumnWidgetLayoutConfigInDev(
  {
    firstChildLowerWidthLimit: LICE_COUNT_TWO_COLUMN_WIDGET_LAYOUT.firstChildLowerWidthLimit,
    firstChildUpperWidthLimit: LICE_COUNT_TWO_COLUMN_WIDGET_LAYOUT.firstChildUpperWidthLimit,
  },
  { min: liceCountMinColumns, max: liceCountMaxColumns }
);
